<template>
    <ion-page>
        <slot name="header-full">
            <ion-header
                v-if="props.header"
                :class="{ blocked }"
                translucent
                mode="ios"
                :collapse="(emptyHeader || noCollapse) ? undefined : collapse"
            >
                <slot name="header">
                    <custom-header
                        :color="headerColor"
                        :back-button="backButton"
                        :empty="emptyHeader"
                        :title="title"
                        :default-href="defaultHref"
                        :fixed-route="fixedRoute"
                        :force-background="forceBackground"
                        :no-animation="noAnimation"
                    >
                        <template #start>
                            <slot name="header-start" />
                        </template>

                        <slot name="header-content" />

                        <template #end>
                            <slot name="header-end" />
                        </template>
                    </custom-header>
                </slot>
            </ion-header>
        </slot>

        <div
            v-if="$slots['fixed']"
            slot="fixed"
            style="z-index: 1; max-height: calc(100vh - var(--ion-safe-area-top) - var(--ion-safe-area-bottom) - 44px);"
            :class="{ blocked, 'overflow-auto': scrollHeader }"
            :key="languageWatcher"
        >
            <slot name="fixed" />
        </div>

        <ion-content :fullscreen="fullscreen" :class="contentClass" :scroll-y="scrollY" :key="languageWatcher">
            <slot />
        </ion-content>

        <ion-footer v-if="props.footer" :key="languageWatcher">
            <slot name="footer">
                <custom-footer toolbar />
            </slot>
        </ion-footer>
    </ion-page>
</template>

<script setup lang="ts">
import { IonContent, IonFooter, IonHeader, IonPage } from '@ionic/vue';
import { ref } from 'vue';

import CustomHeader from "@/components/basePageElements/CustomHeader.vue";
import CustomFooter from "@/components/basePageElements/CustomFooter.vue";

import { BasePageProps } from "@/types/props";

const props = withDefaults(defineProps<BasePageProps>(), {
    header: true,
    sidebar: false,
    footer: false,
    backButton: true,
    contentClass: 'background-gradient-background',
    fullscreen: true,
    collapse: 'fade',
    scrollY: true,
    scrollHeader: true
})

const languageWatcher = ref<number>(0)

window.addEventListener('change-language', () => {
    languageWatcher.value++
})
</script>

<style scoped>
.blocked {
    position: relative;
}

.blocked::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    opacity: 0.3;
    background-color: var(--ion-color-grey1);
    z-index: 11;
}
</style>
